import { render } from "./k2-tooltip.vue?vue&type=template&id=ccff570e&ts=true"
import script from "./k2-tooltip.vue?vue&type=script&lang=ts&setup=true"
export * from "./k2-tooltip.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/tooltip/k2-tooltip.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ccff570e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ccff570e', __exports__)) {
    api.reload('ccff570e', __exports__)
  }
  
  module.hot.accept("./k2-tooltip.vue?vue&type=template&id=ccff570e&ts=true", () => {
    api.rerender('ccff570e', render)
  })

}


export default __exports__